module.exports = __webpack_public_path__ + "static/bonsky_digital-792a16075f89924892ef713c8b52bce5.svg";